import Vue from 'vue'
import Vuex from 'vuex'

// 安装插件
Vue.use(Vuex)

const state = {
    bindCode: ''
}
const mutations = {
    changeBindCode(state, val) {
        state.bindCode = val
    }
}

// 挂载Vue实例上
export default new Vuex.Store({
    state,
    mutations
})

